/**
 * @component {"type":"QuizGame","version":"1.2"}
 */

define('quiz-game',['knockout', 'helpers', 'pagination', 'user-answers', 'training', 'navigation'], function(ko, helpers, Pagination, UserAnswers, Training, Navigation) {
    'use strict';

    return function(viewModel, dataContext) {
        var self = this,
            entityVM = viewModel.entity,
            trainingVM = viewModel.training,
            paging,
            gameMap,
            gameTree = {},
            levels = [],
            timeoutID = -1,
            seconds = 0,
            startTime = 0,
            navigation = new Navigation(),
            userAnswers = new UserAnswers(),
            training = new Training();

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.labelStart = ko.observable('');
        self.labelRestart = ko.observable('');
        self.labelNext = ko.observable('');
        self.labelFinish = ko.observable('');
        self.labelStartPage = ko.observable('');

        self.timeTotal = ko.observable('30');
        self.timeMaxPoints = ko.observable('28.5');
        self.timeoutText = ko.observable('');
        self.pointsText = ko.observable('');

        self.phaseClass = ko.observable("");

        self.points = ko.observable('0');
        self.timePassed = ko.observable('0');
        self.remainingTime = ko.observable('00:00');
        self.remainingClass = ko.observable('0');
        self.noTime = ko.observable(false);

        self.useThreshold = ko.observable(false);
        self.timer = ko.observable('countdown');

        self.useThreshold(true);
        self.timer('total');

        var getQuizGamePaging = function() {
            var ID = entityVM.ID();

            if (!gameMap || !Array.isArray(gameMap) || gameMap.length === 0) {
                gameMap = self.gameMap();
            }

            if (!gameMap || !Array.isArray(gameMap) || gameMap.length === 0) {
                return;
            }

            paging = new Pagination(gameMap, ID, viewModel);

            return paging;
        },
        formatTime = function(time) {
            var total = parseInt(time, 10) || 0,
                min = parseInt(total/60, 10) || 0,
                sec = parseInt(total - min*60, 10) || 0;

            min = (min < 10) ? '0' + min.toString() : min;
            sec = (sec < 10) ? '0' + sec.toString() : sec;

            return min + ':' + sec;
        },
        initTotalTimer = function(sec) {
            var updateTotalTimer = function(sec) {
                var deg = (sec === 60) ? 180 : parseInt(((sec % 60) * 100 / 60 * 1.8), 10);

                if (timeoutID) {
                    clearTimeout(timeoutID);
                }

                self.remainingClass(deg);
                self.remainingTime(formatTime(sec));

                timeoutID = setTimeout(function() {
                   seconds = sec + 1;
                   updateTotalTimer(seconds);
                }, 1000);
            };

            updateTotalTimer(sec);

            startTime = new Date();
        },
        initTimer = function() {
            var updateTimer = function(passed) {
                var contents,
                    i = 0,
                    total = self.timeTotal() || 1,
                    remaining = formatTime(total - passed),
                    deg = parseInt((passed * 100 / total * 1.8), 10);

                if (timeoutID) {
                    clearTimeout(timeoutID);
                }

                self.remainingClass(deg);
                self.remainingTime(remaining);

                self.phaseClass('');

                if (parseInt(total) === parseInt(passed)) {
                    contents = document.querySelectorAll('.js-quiz-game-content');
                    i = contents.length;
                    while(i--) {
                        contents[i].innerHTML = (i === 0) ? self.timeoutText() : '';
                    }
                    self.noTime(true);
                    self.points(0);
                    self.phaseClass('quizgame-timeout');
                }

                if (total > passed) {
                    self.timePassed(passed);
                    timeoutID = setTimeout(function() {
                       updateTimer(++passed);
                    }, 1000);
                }
            };

            self.timePassed(0);
            updateTimer(0);

            startTime = new Date();
        },
        stopTimer = function() {
            if (timeoutID) {
                clearTimeout(timeoutID);
            }
        };

        self.quizPassed = ko.observable(false);

        self.visibleScoreboard = ko.observable(entityVM.isQuizGame());

        self.quizContent = ko.computed(function() {
            var ID = entityVM.ID(),
                game = helpers.content.getQuizGame(ID, training.contentEntities),
                entity = training.getEntity(ID),
                hidden = ID === game.ID && !userAnswers.isQuizGamePagePassed(ID);

            if (entity && helpers.entity.isQuizPage(entity)) {
                var progress = userAnswers.getQuizPageProgress(ID);

                if (!progress || !progress.isPassed) {
                    self.quizPassed(false);
                    self.phaseClass('quizgame-failed');
                } else {
                    self.quizPassed(true);
                    self.phaseClass('quizgame-passed');
                }
            }

            if (!game.isQuizGame) {
                return;
            }

            self.visibleScoreboard(!hidden);

            var content = game.content;

            self.labelStart(content.startButtonLabel);
            self.labelRestart(content.restartButtonLabel);
            self.labelNext(content.nextButtonLabel);
            self.labelFinish(content.finishButtonLabel);
            self.labelStartPage(content.startPageLabel);
            self.timeTotal(content.answerTime);
            self.timeMaxPoints(content.maxPointsTime);
            self.timeoutText(content.timeoutText);
            self.pointsText(content.pointsText);
            self.useThreshold(!!content.useThreshold);
            self.timer(content.timer);
        });

        self.gameMap = function(ID) {
            ID = ID || entityVM.ID();

            var res = [],
                game = (entityVM.isQuizGame()) ? helpers.content.getQuizGame(ID, training.contentEntities) : null,
                progress,
                childrenID;

            var entity = (game && game.isQuizGame) ? training.getEntity(game.ID) : null,
                children = (entity && Array.isArray(entity.children) && entity.children.length) ? entity.children : null;

            if (!children) {
                return res;
            }

            for (var i = 0; i < children.length; i++) {
                childrenID = children[i].contentEntityId;

                if (children[i].typeId === 19) {
                    progress = userAnswers.getQuizPageProgress(childrenID);

                    if (progress && Array.isArray(progress.childrenID)) {
                        res = res.concat(progress.childrenID);
                    }
                }

                res.push(childrenID);
            }

            return res;
        };

        self.isLastSection = ko.computed(function() {
            var ID = entityVM.ID();

            return ((levels.indexOf(ID) + 1) === levels.length) ? true : false;
        });

        self.quizContentText = trainingVM.quizContentText;

        self.loadInformation = function(ID) {
            ID = ID || entityVM.ID();

            var entity = trainingVM.getEntity(ID),
                children = (entity) ? entity.children : [],
                points = 0,
                userAnswer = userAnswers.getUserAnswer(ID),
                updateGameTree = function(ID, children, gameMap) {
                    children = children || [];

                    var i = children.length;

                    while(i--) {
                        if (gameMap.indexOf(children[i].contentEntityId) > -1) {
                            if (!gameTree[ID]) {
                                gameTree[ID] = [];
                            }
                            gameTree[ID].push(children[i].contentEntityId);
                        }
                    }
                };

            levels = [];
            gameTree = {};

            for(var i = 0; i < children.length; i++) {
                if (children[i].typeId === 19) {
                    levels.push(children[i].contentEntityId);
                    updateGameTree(children[i].contentEntityId, children[i].children, gameMap);
                }
            }

            if (userAnswer && userAnswer.hasOwnProperty('points')) {
                points = userAnswer.points;
            }

            self.points(points);
            self.noTime(false);
        };

        self.calculatePoints = function(remaining, max, indx, len) {
            var percent = (remaining > max) ? 100 : (remaining/max) * 100,
                multiplier = (indx + len) / (2*len - (len-1)/2);

            return parseInt(percent * multiplier, 10);
        };

        self.storePoints = function() {
            var game = helpers.content.getQuizGame(entityVM.ID(), training.contentEntities);

            if (!game || !game.ID) {
                return;
            }

            userAnswers.logProgress(game.ID, {
                'points': self.points()
            })
        };

        self.calculateTotalPoints = function(passed) {
            var ID = entityVM.ID(),
                points = (200 - passed);

            if (points < 0 || !userAnswers.isTaskCorrect(ID)) {
                points = 0;
            }

            return parseInt(points, 10);
        };

        self.updateTotalPoints = function() {
            var points = parseInt(self.points(), 10),
                passed = parseFloat((new Date().getTime() - startTime.getTime()) / 1000);

            points += self.calculateTotalPoints(passed);

            self.points(points);
        };

        self.updatePoints = function() {
            var parentID = entityVM.parentId(),
                points = parseInt(self.points(), 10),
                endTime = new Date(),
                remaining = parseFloat(self.timeTotal()) * 1000 - (endTime.getTime() - startTime.getTime()),
                max = parseFloat(self.timeMaxPoints() * 1000),
                indx = levels.indexOf(parentID) + 1,
                len = levels.length;

            remaining = (remaining > 0) ? remaining : 0;

            points += self.calculatePoints(remaining, max, indx, len);

            self.points(points);
        };

        self.canContinue = function(ID) {
            var correct = userAnswers.isTaskCorrect(ID),
                parentID = entityVM.parentId(),
                arr = gameTree[parentID] || [],
                max = 0;

            if (correct) {
                return true;
            }

            if (self.useThreshold()) {
                for (var i = 0; i < arr.length; i++) {
                    max += (userAnswers.isTaskCorrect(arr[i]) || !userAnswers.isTaskPageAnswered(arr[i])) ? 1 : 0;
                }
            }

            var userScore = (arr.length) ? (max/arr.length) * 100 : 0,
                entity = trainingVM.getEntity(parentID);

            return (userScore >= entity.contentEntity.passThreshold || entity.contentEntity.passAlways) ? true : false;

        };

        self.taskSubmit = function(obj) {
            var ID = entityVM.ID(),
                isLastTask = function(ID) {
                    var entity = training.getContent(ID),
                        parentID = (entity) ? entity.parentID : '',
                        progress = userAnswers.getQuizPageProgress(parentID);

                    if (!progress || !Array.isArray(progress.childrenID)) {
                        return false;
                    }

                    return (progress.childrenID[progress.childrenID.length - 1] === ID && (levels.indexOf(parentID) + 1) === levels.length) ? true : false;
                };

            window.initPageRender = new Date();

            trainingVM.buttonClick(obj);

            if (self.canContinue(ID)) {

                var correctAnswer = userAnswers.isTaskCorrect(ID);

                if (correctAnswer) {
                    if (self.timer() === 'total') {
                        self.updateTotalPoints();
                    } else {
                        self.updatePoints();
                    }
                }

                paging = getQuizGamePaging();

                if (paging) {
                    navigation.navigateTo(gameMap[paging.page]);
                }

                if (isLastTask(ID)) {
                    self.storePoints();
                    trainingVM.setCustomPoints(self.points()); // store points to LMS
                }
            } else {
                navigation.navigateTo(entityVM.parentId());
            }
        };

        self.isFirstPage = ko.computed(function() {
            var ID = entityVM.ID();

            paging = getQuizGamePaging();

            return (ID && paging && paging.page === 0) ? true : false;
        });

        self.isLastPage = ko.computed(function() {
            var ID = entityVM.ID();

            paging = getQuizGamePaging();

            return (ID && paging && paging.page === paging.total) ? true : false;
        });

        self.isPrevVisible = ko.computed(function() {
            var ID,
                entity;

            paging = getQuizGamePaging();

            if (paging && paging.page === 0) {
                return true;
            }

            ID = entityVM.ID();
            entity = training.getEntity(ID);

            if (!entity) {
                return false;
            }

            if (!helpers.entity.isQuizTaskPage(ID, training.contentEntities) && !helpers.entity.isQuizPage(entity)) {
                return true;
            }

            return false;
        });

        self.isNextVisible = ko.computed(function() {
            var ID,
                entity;

            if (training.modularMenuPageID && training.containerID === entityVM.parentID()) {
                return false;
            }

            if (self.isLastSection()) {
                return true;
            }

            ID = entityVM.ID();
            entity = training.getEntity(ID);

            if (!entity) {
                return false;
            }

            if (helpers.entity.isQuizTaskPage(ID, training.contentEntities) || helpers.entity.isQuizPage(entity)) {
                return false;
            }

            return true;
        });

        self.goToPage = function(nbr) {
            window.initPageRender = new Date();

            navigation.navigateTo(gameMap[nbr]);
        };

        self.start = function() {
            var ID = entityVM.ID(),
                game = helpers.content.getQuizGame(ID, training.contentEntities),
                userAnswers = new UserAnswers();

            window.initPageRender = new Date();

            if (game && game.ID) {
                userAnswers.resetQuizGameAnswers(game.ID);
            }

            self.points(0);
            self.noTime(false);

            self.storePoints();

            paging = getQuizGamePaging();

            if (paging) {
                navigation.navigateTo(gameMap[0]);
            }

            if (self.timer() === 'total') {
                initTotalTimer(0);
            }

            self.phaseClass('');
        };

        self.restart = function() {
            var ID = (self.isFirstPage()) ? entityVM.ID() : entityVM.parentID(),
                entity;

            userAnswers.resetQuizGameAnswers(ID);

            for (var i = 0; i < gameMap.length; i++) {
                entity = training.getEntity(gameMap[i]);

                if (entity && entity.typeId === 19) {
                    userAnswers.resetComputedQuizMap(gameMap[i]);
                }
            }

            seconds = 0;
            gameMap = self.gameMap(ID);
            self.loadInformation(ID);

            self.start();
        };

        self.begining = function() {
            var ID = entityVM.ID(),
                game = helpers.content.getQuizGame(ID, training.contentEntities);

            if (game.ID) {
                navigation.navigateTo(game.ID);
            }

            self.phaseClass('');
        };

        self.complete = function() {
            trainingVM.next();
        };

        self.progress = function() {
            var res = [],
                arr = gameMap || [],
                entity;

            for (var i = 0; i < arr.length; i++) {
                entity = training.getEntity(arr[i]);

                if (entity && helpers.entity.isTaskPage(entity) && userAnswers.isTaskPageAnswered(arr[i])) {

                    res.push({
                        ID: arr[i],
                        entity: entity,
                        taskAnswers: training.getTaskAnswers(arr[i]),
                        userAnswers: training.getTaskAnswers(arr[i], userAnswers.getTaskAnswersID(arr[i])),
                        isCorrect: userAnswers.isTaskCorrect(arr[i])
                    });
                }
            }

            return res;
        };

        self.progressHTML = function() {
            var res = '<table class="quiz-game-res">',
                arr = self.progress(),
                getTaskAnswers = function(arr) {
                    var res = '';

                    for (var i = 0; i < arr.length; i++) {
                        res += (res) ? '/ ' + arr[i] : arr[i];
                    }

                    return res;
                },
                getQuestions = function(arr) {
                    var res = '';

                    for (var i = 0; i < arr.length; i++) {
                        res += (res) ? '/ ' + arr[i].text : arr[i].text;
                    }

                    return res;
                };

            if (!arr) {
                return '';
            }

            for (var i = 0; i < arr.length; i++) {
                res += (arr[i].isCorrect) ? '<tr class="quiz-game-res-row quiz-game-res-row-correct">' : '<tr class="quiz-game-res-row quiz-game-res-row-incorrect">';
                res += '<td class="quiz-game-res-col quiz-game-res-col-1">' + (i + 1) + '</td>';
                res += '<td class="quiz-game-res-col quiz-game-res-col-2">' + getQuestions(arr[i].entity.questions) + '</td>';
                res += '<td class="quiz-game-res-col quiz-game-res-col-3">' + getTaskAnswers(arr[i].taskAnswers) + '</td>';
                res += '</tr>';
            }

            res += '</table>';

            return res;
        };

        self.initiate = ko.computed(function() {
            if (entityVM.isQuizGame() && !entityVM.isQuizPage() && !entityVM.isQuizTask() && self.isFirstPage()) {
                seconds = 0;
                gameMap = self.gameMap();
            }

            stopTimer();

            if (self.isFirstPage()) {
                self.loadInformation();
            }

            if (entityVM.isQuizGame() && entityVM.isQuizTask()) {
                if (self.timer() === 'total') {
                    initTotalTimer(seconds);
                } else {
                    initTimer();
                }
            }
        }).extend({rateLimit: 0});
    };

});

